var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_975_321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.52475 0H1.85025C0.830031 0 0 0.830031 0 1.85025V5.52475C0 6.54497 0.830031 7.375 1.85025 7.375H5.52475C6.54497 7.375 7.375 6.54497 7.375 5.52475V1.85025C7.375 0.830031 6.54497 0 5.52475 0ZM6.125 5.52475C6.125 5.85572 5.85572 6.125 5.52475 6.125H1.85025C1.51928 6.125 1.25 5.85572 1.25 5.52475V1.85025C1.25 1.51928 1.51928 1.25 1.85025 1.25H5.52475C5.85572 1.25 6.125 1.51928 6.125 1.85025V5.52475Z",
    fill: "#2487FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.125 0H10.5C9.46613 0 8.625 0.841125 8.625 1.875V5.5C8.625 6.53387 9.46613 7.375 10.5 7.375H14.125C15.1589 7.375 16 6.53387 16 5.5V1.875C16 0.841125 15.1589 0 14.125 0ZM14.75 5.5C14.75 5.84462 14.4696 6.125 14.125 6.125H10.5C10.1554 6.125 9.875 5.84462 9.875 5.5V1.875C9.875 1.53038 10.1554 1.25 10.5 1.25H14.125C14.4696 1.25 14.75 1.53038 14.75 1.875V5.5Z",
    fill: "#2487FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52475 8.625H1.85025C0.830031 8.625 0 9.45503 0 10.4753V14.1497C0 15.17 0.830031 16 1.85025 16H5.52475C6.54497 16 7.375 15.17 7.375 14.1497V10.4753C7.375 9.45503 6.54497 8.625 5.52475 8.625ZM6.125 14.1497C6.125 14.4807 5.85572 14.75 5.52475 14.75H1.85025C1.51928 14.75 1.25 14.4807 1.25 14.1497V10.4753C1.25 10.1443 1.51928 9.875 1.85025 9.875H5.52475C5.85572 9.875 6.125 10.1443 6.125 10.4753V14.1497Z",
    fill: "#2487FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.125 8.625H10.5C9.46613 8.625 8.625 9.46613 8.625 10.5V14.125C8.625 15.1589 9.46613 16 10.5 16H14.125C15.1589 16 16 15.1589 16 14.125V10.5C16 9.46613 15.1589 8.625 14.125 8.625ZM14.75 14.125C14.75 14.4696 14.4696 14.75 14.125 14.75H10.5C10.1554 14.75 9.875 14.4696 9.875 14.125V10.5C9.875 10.1554 10.1554 9.875 10.5 9.875H14.125C14.4696 9.875 14.75 10.1554 14.75 10.5V14.125Z",
    fill: "#2487FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_975_321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon);
export default __webpack_public_path__ + "static/media/grid-icon.67a79268f0d59281a829e6c3a1eece97.svg";
export { ForwardRef as ReactComponent };